/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { createRouter, createWebHistory } from "vue-router"

import { authState } from "@/domain/auth/auth.state"
import { isTokenValid } from "@/domain/auth/auth.service"

import LoginView from "@/reflection/Core/LoginView.vue"

import { navigationFallbackData } from "@/domain/navigation/navigation.fallback"
import { mapNavigationRoutes } from "@/domain/navigation/navigation.routes.mapper"

/*
Navigation → Routes
*/

const navigationRoutes = mapNavigationRoutes(
  navigationFallbackData.items
)

/*
Static routes
*/

const routes = [

  {
    path: "/login",
    component: LoginView,
    meta: { requiresAuth: false }
  },

  ...navigationRoutes,

  {
    path: "/:pathMatch(.*)*",
    redirect: "/login"
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

/*
Auth guard
*/

router.beforeEach((to) => {

  const authenticated = authState.isAuthenticated || isTokenValid()

  authState.isAuthenticated = authenticated

  if (to.meta.requiresAuth && !authenticated) {
    return {
      path: "/login",
      query: { redirect: to.fullPath }
    }
  }

  if (to.path === "/login" && authenticated) {
    return "/instances"
  }

})

export default router
